import { Popover as ChakraPopover } from '@chakra-ui/react';

import { CloseButton } from './CloseButton';
import { Portal } from './Portal';

type PopoverContentProps = ChakraPopover.ContentProps & {
  portalled?: boolean;
  portalRef?: React.RefObject<HTMLElement>;
};

export const PopoverContent = ({
  ref,
  ...props
}: PopoverContentProps & { ref?: React.RefObject<HTMLDivElement | null> }) => {
  const { portalled = true, portalRef, ...rest } = props;
  return (
    <Portal portalled={portalled} portalRef={portalRef}>
      <ChakraPopover.Positioner>
        <ChakraPopover.Content ref={ref} {...rest} />
      </ChakraPopover.Positioner>
    </Portal>
  );
};

export const PopoverArrow = ({
  ref,
  ...props
}: ChakraPopover.ArrowProps & { ref?: React.RefObject<HTMLDivElement | null> }) => {
  return (
    <ChakraPopover.Arrow {...props} ref={ref}>
      <ChakraPopover.ArrowTip />
    </ChakraPopover.Arrow>
  );
};

export const PopoverCloseTrigger = ({
  ref,
  ...props
}: ChakraPopover.CloseTriggerProps & { ref?: React.RefObject<HTMLButtonElement | null> }) => {
  return (
    <ChakraPopover.CloseTrigger
      position="absolute"
      top="1"
      insetEnd="1"
      zIndex="docked"
      {...props}
      asChild
      ref={ref}
    >
      <CloseButton size="sm" />
    </ChakraPopover.CloseTrigger>
  );
};

export const PopoverTitle = ChakraPopover.Title;
export const PopoverDescription = ChakraPopover.Description;
export const PopoverFooter = ChakraPopover.Footer;
export const PopoverHeader = ChakraPopover.Header;
export const PopoverRoot = ChakraPopover.Root;
export const PopoverBody = ChakraPopover.Body;
export const PopoverTrigger = ChakraPopover.Trigger;
